module.exports = __webpack_public_path__ + "img/ComingSoon.5649f8b8.png";